import React from 'react';
import {
  Box,
  Col,
  Glyph,
  useDirection,
  Flex,
} from '@edreamsodigeo/prisma-design-system';
import { useFlowTools } from 'flowTools/useFlowTools';
import SegmentDuration from '../SegmentDuration';
import StopoverQuantity from '../StopoverQuantity';
import TripDivider from '../TripDivider';

export interface ProductIconProps {
  type: 'PLANE' | 'TRAIN';
}

const ProductIcon: React.FC<ProductIconProps> = ({ type }) => {
  const isRtl = useDirection();
  return (
    <Flex alignItems="center">
      {type === 'PLANE' ? (
        isRtl ? (
          <Glyph
            category="Planes"
            name="FlightLeft"
            color="primary.50"
            size={'tiny'}
          />
        ) : (
          <Glyph
            category="Planes"
            name="FlightRight"
            color="primary.50"
            size={'tiny'}
          />
        )
      ) : (
        <Glyph
          category="TravelProducts"
          name="Train"
          color="trainProductColor"
          size={'tiny'}
        />
      )}
    </Flex>
  );
};

export type SegmentTripProps = {
  transportTypes: ('PLANE' | 'TRAIN')[];
  duration: number;
  numberOfStops: number;
  isAlternativeItinerary?: boolean;
};

const SegmentTrip: React.FC<SegmentTripProps> = ({
  transportTypes,
  duration,
  numberOfStops,
  isAlternativeItinerary = false,
}) => {
  const { isDesktop, isMobile } = useFlowTools();
  const showInfo = !isAlternativeItinerary || isDesktop;
  const transportType = (
    <Flex>
      {transportTypes.map((transportType, index) => (
        <ProductIcon type={transportType} key={index} />
      ))}
    </Flex>
  );
  return (
    <Flex
      alignItems={'center'}
      justifyContent={'center'}
      flexDirection="column"
      width="100%"
      height="100%"
    >
      {showInfo && (
        <Flex
          flexDirection="column"
          width="100%"
          alignItems="center"
          mb={'tiny'}
        >
          <Col>
            <SegmentDuration duration={duration} />
          </Col>
        </Flex>
      )}

      <Flex
        flexDirection="row"
        width="100%"
        justifyContent="space-between"
        marginTop={isMobile && isAlternativeItinerary ? 'minus_small' : '0'}
      >
        <Col width="100%">
          <TripDivider />
        </Col>
        <Col>
          <Box position="relative" width="100%" marginLeft="minus_2x_small">
            <Box
              alignItems="center"
              display="flex"
              position="absolute"
              sx={{
                right: '0',
                transform: 'translateY(-50%)',
              }}
            >
              {transportType}
            </Box>
          </Box>
        </Col>
      </Flex>
      {showInfo && (
        <Flex flexDirection="column" width="100%" alignItems="center">
          <Col>
            <StopoverQuantity quantity={numberOfStops} />
          </Col>
        </Flex>
      )}
    </Flex>
  );
};

SegmentTrip.defaultProps = {
  transportTypes: [],
};

export default SegmentTrip;
